import styled from 'styled-components'
import { device } from '../Breakpoints'
import { colors } from '../Colors'

const Container = styled.section`
  color: white;
  background: ${colors.laranjaGradienteReverso};
  box-sizing: border-box;
  margin: 0em 0 1em;
  padding: 2em;
  width: 100%;
  h2 {
    width: 100%;
    display: block;
  }
  a {
    width: 100%;
    max-width: 175px;
    height: 50px;
    text-align: center;
    flex-grow: 0;
    background-color: #ffffff;
    padding: 0 2.3em;
    border-radius: 50px;
    text-transform: uppercase;
    font-size: 0.8em;
    text-decoration: none;
    color: #ff8f8c;
    opacity: 1;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    :hover {
      opacity: 0.8;
    }
    svg {
      color: #793939;
    }
    @media ${device.mobileL} {
      margin: auto;
    }
  }
  ul {
    padding: 0;
    margin: 0;
    li {
      margin: 0 0 1.5em 0;
      padding: 0;
      list-style: none;
      background: #ffffff;
      box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
      :last-child {
        margin: 0;
      }
      .linkHeader {
        background: #793939;
        padding: 0.5em 2em;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media ${device.mobileL} {
          flex-wrap: wrap;
          padding: 2em;
        }
        h3 {
          font-size: 1em;
          position: relative;
          padding: 0.6 em 0;
          font-weight: normal;
          margin-top: 1em;
          :before {
            position: absolute;
            content: '';
            top: -10px;
            left: 0;
            border: 1px solid #a57777;
            width: 10%;
            @media ${device.mobileL} {
              left: 45%;
            }
          }
          :after {
            position: absolute;
            content: '';
            bottom: -10px;
            left: 0;
            border: 1px solid #a57777;
            width: 10%;
            @media ${device.mobileL} {
              left: 45%;
            }
          }
          @media ${device.mobileL} {
            width: 100%;
            text-align: center;
            margin-bottom: 2em;
          }
        }
      }
      .linkDescription {
        padding: 2em;
        p {
          color: ${colors.cinza};
          font-size: 0.9em;
        }
      }
    }
  }
`

export default Container
